module.exports = __webpack_public_path__ + "img/map.b8bc6926.jpg";